module.exports = __webpack_public_path__ + "img/170.06e4dacc.jpg";